import { render } from "./ResultListItem.vue?vue&type=template&id=af00190a"
import script from "./ResultListItem.vue?vue&type=script&lang=ts"
export * from "./ResultListItem.vue?vue&type=script&lang=ts"
script.render = render

export default script